export const LC_PROCESS_DATA   = 'processData'
export const LC_RENDER         = 'render'

export enum LifecycleAction {
    PROCESS_DATA    = 'processData',
    RENDER          = 'render',

    // New ... used to render with setForceUpdate can be used in different cases
    // i.e when CF changes - the item doesnt change but wee need new render because CF option label has changed
    RENDER_FORCE    = 'render-force',
    FILTER          = 'filter', // experimental
    SORT            = 'sort',   // experimental
}